import { Model } from '../parents/model';

export class OrderDiscountModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  static ATTR_METHOD = 'method';

  static ATTR_OPERATION = 'operation';

  static ATTR_PERCENTS = 'percents';

  static ATTR_AMOUNT = 'amount';

  static ATTR_VALIDITY = 'validity';

  static ATTR_PRIORITY = 'priority';

  static ATTR_IS_FOR_PURCHASE = 'is_for_purchase';

  static ATTR_CODE = 'code';

  static ATTR_FREE_SHIPPING = 'free_shipping';

  static ATTR_DISCOUNT_ID = 'discount_id';

  static ATTR_ORDER_ID = 'order_id';

  static ATTR_DISCOUNTED_AMOUNT = 'discounted_amount';

  static ATTR_DISCOUNTED_TAXED_AMOUNT = 'discounted_taxed_amount';

  static ATTR_CREATED_AT = 'created_at';

  static ATTR_TAX_RATE = 'tax_rate';

  get name() {
    return this.attributes[OrderDiscountModel.ATTR_NAME];
  }

  get method() {
    return this.attributes[OrderDiscountModel.ATTR_METHOD];
  }

  get operation() {
    return this.attributes[OrderDiscountModel.ATTR_OPERATION];
  }

  get percents() {
    return this.attributes[OrderDiscountModel.ATTR_PERCENTS];
  }

  get amount() {
    return this.attributes[OrderDiscountModel.ATTR_AMOUNT];
  }

  get validity() {
    return this.attributes[OrderDiscountModel.ATTR_VALIDITY];
  }

  get priority() {
    return this.attributes[OrderDiscountModel.ATTR_PRIORITY];
  }

  get isForPurchase() {
    return this.attributes[OrderDiscountModel.ATTR_IS_FOR_PURCHASE];
  }

  get code() {
    return this.attributes[OrderDiscountModel.ATTR_CODE];
  }

  get freeShipping() {
    return this.attributes[OrderDiscountModel.ATTR_FREE_SHIPPING];
  }

  get discountId() {
    return this.attributes[OrderDiscountModel.ATTR_DISCOUNT_ID];
  }

  get orderId() {
    return this.attributes[OrderDiscountModel.ATTR_ORDER_ID];
  }

  get discountedAmount() {
    return this.attributes[OrderDiscountModel.ATTR_DISCOUNTED_AMOUNT];
  }

  get discountedTaxedAmount() {
    return this.attributes[OrderDiscountModel.ATTR_DISCOUNTED_TAXED_AMOUNT];
  }

  get createdAt() {
    return this.attributes[OrderDiscountModel.ATTR_CREATED_AT];
  }

  get taxRate() {
    return this.attributes[OrderDiscountModel.ATTR_TAX_RATE];
  }
}
